import { shallowEqual, useSelector } from 'react-redux'

type User = {
  jivo_code?: string
  timezone?: string
  err: null | string
  loading: boolean
  result: string
  id: number | null
  parent: null | {
    id: number
  }
  student: null | {
    id: number
  }
  employee: null | {
    id: number
  }
  name: {
    first: string
    last: string
    middle: string
  }
  update: {
    password: boolean
    phone: boolean
  }
  avatar: string
  committees: Array<number>
  email: string | null
  phone: string | null
  expired: number
  savingToken: boolean
  balance: {
    primary: null | number
    cafeteria: null | number
  }
  role_id: number | null
  type: 'parent' | 'student' | 'employee' | ''
  shop: {
    enabled: boolean
    user_id: null | string
    user_token: null | string
  }
}

export function useUser() {
  const res: User = useSelector((state: any) => state.user, shallowEqual)

  return res
}
